<template>
	<setting
		:class="`element element--setting element--setting--${name}`"
		:element-translation="i18n ? elementTranslation.found : elementTranslation.missing"
		:config-active="active"
	>
		<label class="element__label" :for="id || name">
			{{ i18n ? $t(`${content}`) : content }}
		</label>

		<input
			class="element__input"
			:name="name"
			:id="id || name"
			:type="type"
			:inputmode="inputmode"
			:placeholder="placeholder"
			@input.stop="updateValue($event)"
			:value="value"
		/>
	</setting>
</template>

<script>
import { elementTranslation } from '../../tools/consts';
export default {
	props: {
		name: String,
		id: String,
		type: String,
		inputmode: String,
		pattern: String,
		content: String,
		i18n: Boolean,
		update: Function,
		placeholder: String,
		active: Boolean,
		value: [String, Number, Boolean],
	},
	computed: {},
	methods: {
		updateValue(event) {
			if (this.update) {
				this.update(
					this.type === 'checkbox'
						? this.parseValue(event.target.checked)
						: this.parseValue(event.target.value)
				);
			}
		},
		parseValue(value) {
			switch (this.type) {
				case 'number':
					return Number(value);
				case 'checkbox':
					return Boolean(value);
				default:
					return value;
			}
		},
	},
	created() {
		this.elementTranslation = elementTranslation;
	},
};
</script>

<style lang="scss"></style>
